import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './en.json';
import it from './it.json';
import fri from './fri.json';

// import flagIt from '@/assets/images';
import flagUk from '@/assets/images/flag-uk.png';
import flagFriuli from '@/assets/images/flag-friuli.png';
import flagIt from '@/assets/images/FLAG-ITALY.jpg';

export const translations = {
  en,
  it,
  fri,
};

export type Language = keyof typeof translations;

/**
 * Fallback language when no language is selected
 * Used throughout the app as default
 */
export const FALLBACK_LANGUAGE = 'it' as const;

//Le chiavi 'countryFlagLag' devono essere uguali alle chiavi di 'translations'
export const countryFlagLag = {
  en: flagUk,
  it: flagIt,
  fri: flagFriuli,
}


/**
 * Array of all supported languages
 * Useful for validation and iteration
 */
export const SUPPORTED_LANGUAGES: Language[] = Object.keys(
  translations
) as Language[];

// Detect browser language or fallback to Italian (attualmente lo inseriamo direttamente in italiano)
// const browserLanguage = navigator.language.split('-')[0];
// const defaultLanguage: Language =
//   (SUPPORTED_LANGUAGES.includes(browserLanguage as Language)
//     ? browserLanguage
//     : 'it') as Language;
// Get default language: try localStorage first, then fallback to Italian
const getDefaultLanguage = (): Language => {
  const stored = typeof window !== 'undefined' ? localStorage.getItem('language') : null;
  if (stored && SUPPORTED_LANGUAGES.includes(stored as Language)) {
    return stored as Language;
  }
  return 'it';
};

const defaultLanguage = getDefaultLanguage();

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: { translation: en },
      it: { translation: it },
      fri: { translation: fri },
    },
    lng: defaultLanguage, // default language
    fallbackLng: 'it', // fallback language
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      useSuspense: false, // disable suspense for now
    },
  });

// Persist language preference to localStorage when it changes
i18n.on('languageChanged', (language) => {
  localStorage.setItem('language', language);
});

export default i18n;
